import { StaticInput } from '@framework/form/inputs/static/StaticInput.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { Button, Space } from 'antd';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IAdvancedMultiSelectWidget } from '../advanced-multi-select/IAdvancedMultiSelectWidget.ts';
import { type IAdvancedSingleSelectWidget } from '../advanced-single-select/IAdvancedSingleSelectWidget.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { getDinamicButtonProps } from './utils/getDinamicButtonProps.tsx';

export const FullWidthCompact = styled(Space.Compact)`
  width: 100%;
`;

export interface IAdvancedSelectWidgetPreviewProps
  extends IWidgetComponentProps<
    IAdvancedSingleSelectWidget | IAdvancedMultiSelectWidget
  > {}

/**
 * Preview del widget di selezione avanzata (singola/multipla)
 */
export function AdvancedSelectWidgetPreview(
  props: IAdvancedSelectWidgetPreviewProps,
) {
  const options = getWidgetProps(props);

  const { buttonText } = getDinamicButtonProps(
    props.widget.buttonText,
    props.widget.buttonTextAfter,
    false,
  );

  return (
    <ConfigFormItem
      name={'string'}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <FlexRow
        gutter={6}
        align="flex-start"
        right={
          <Button size="large" type="primary" style={{ flex: 0 }}>
            {buttonText}
          </Button>
        }
      >
        <StaticInput
          value={''}
          placeholder={options.placeholder}
          loading={false}
        />
      </FlexRow>
    </ConfigFormItem>
  );
}
